// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mr-top {
	margin-top: 40px;
	margin-bottom: 40px;
}

.mr-left {
	margin-left: 20px;
}

.example {
	margin: 20px 0;
	margin-bottom: 20px;
	padding: 30px 50px;
	text-align: center;
	background: rgba(0, 0, 0, 0.05);
	border-radius: 4px;
}

.code-box-demo {
	overflow-x: auto;
}

.code-box-demo .ant-segmented {
	margin-bottom: 10px;
}

label {
	margin-bottom: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/franchise/FranchiseList/Franchises.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B","sourcesContent":[".mr-top {\n\tmargin-top: 40px;\n\tmargin-bottom: 40px;\n}\n\n.mr-left {\n\tmargin-left: 20px;\n}\n\n.example {\n\tmargin: 20px 0;\n\tmargin-bottom: 20px;\n\tpadding: 30px 50px;\n\ttext-align: center;\n\tbackground: rgba(0, 0, 0, 0.05);\n\tborder-radius: 4px;\n}\n\n.code-box-demo {\n\toverflow-x: auto;\n}\n\n.code-box-demo .ant-segmented {\n\tmargin-bottom: 10px;\n}\n\nlabel {\n\tmargin-bottom: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
